module.exports = __webpack_public_path__ + "static/media/learn-test-export.9bbcb91a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/learn-test-export.jpg
// module id = 90
// module chunks = 3